var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PreviewForm',{attrs:{"source":_vm.source,"is-loading":_vm.isLoading},on:{"ok":_vm.ok,"cancel":_vm.cancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }